import { TransformKind } from "../display/SpriteConst";
import { Event } from "../events/Event";
import { Button } from "./Button";
export class Radio extends Button {
    get value() {
        return this._value != null ? this._value : this.label;
    }
    set value(obj) {
        this._value = obj;
    }
    constructor(skin = null, label = "") {
        super(skin, label);
        this.toggle = false;
        this._autoSize = false;
    }
    _transChanged(kind) {
        super._transChanged(kind);
        if ((kind & TransformKind.Width) != 0) {
            if (!this._autoSize)
                this._text.width = this._width - this._text.x;
        }
    }
    preinitialize() {
        super.preinitialize();
        this.toggle = false;
        this._autoSize = false;
    }
    initialize() {
        super.initialize();
        this.createText();
        this._text.align = "left";
        this._text.valign = "top";
        this._text.width = null;
        this.on(Event.CLICK, this, this.onClick);
    }
    onClick(e) {
        this.selected = true;
    }
    changeClips() {
        super.changeClips();
        if (!this._autoSize)
            this._text.width = this.width - this._text.x;
    }
}
